import { render, staticRenderFns } from "./SupportCategoryView.vue?vue&type=template&id=34919c5e&scoped=true&"
import script from "./SupportCategoryView.vue?vue&type=script&lang=js&"
export * from "./SupportCategoryView.vue?vue&type=script&lang=js&"
import style0 from "./SupportCategoryView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SupportCategoryView.vue?vue&type=style&index=1&id=34919c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34919c5e",
  null
  
)

export default component.exports